import { StyleSheet, Font } from '@react-pdf/renderer';

// Use standard fonts that are bundled with react-pdf
Font.register({
  family: 'Helvetica',
  fonts: [
    { src: 'Helvetica' },
    { src: 'Helvetica-Bold', fontWeight: 700 },
  ]
});

export const styles = StyleSheet.create({
  document: {
    width: '100%',
    height: '100%',
    padding: 40,
    fontFamily: 'Helvetica', // Use Helvetica instead of Roboto
  },
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    paddingBottom: 60,
    fontFamily: 'Helvetica',
  },
  // Header styles
  header: {
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    color: '#666666',
    marginBottom: 4,
  },
  // Table styles
  table: {
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#e5e7eb',
    marginBottom: 15,
  },
  tableHeader: {
    backgroundColor: '#f9fafb',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  headerText: {
    fontWeight: 700,
    fontSize: 12,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
    minHeight: 35,
    alignItems: 'center',
  },
  tableCell: {
    padding: 8,
    fontSize: 12,
    flexWrap: 'wrap',
    overflow: 'hidden',
    borderRightWidth: 1,
    borderRightColor: '#e5e7eb',
  },
  // Plan indicator styles
  planIndicator: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 4,
  },
  planRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  // Category styles
  categoryTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginTop: 5,
    marginBottom: 10,
  },
  // Parent category (larger title)
  parentCategoryTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginTop: 5,
    marginBottom: 10,
  },
  // Child category (smaller title with arrow)
  childCategoryTitle: {
    fontSize: 14,
    fontWeight: 600,
    marginTop: 3,
    marginBottom: 8,
    marginLeft: 15,
    color: '#666666',
    lineHeight: 1.2,
    textAlign: 'left',
    alignItems: 'center',
  },
  categoryInfo: {
    marginBottom: 8,
  },
  categoryInfoText: {
    fontSize: 12,
    marginBottom: 4,
  },
  categoryInfoLabel: {
    fontWeight: 700,
    fontSize: 12,
  },
  // Style for the price value when shown next to the title
  categoryPriceValue: {
    fontSize: 16, // Match title or adjust as needed
    fontWeight: 400, // Regular weight, not bold like title
    color: '#333333', // Adjust color if needed
  },
  // Section styles
  section: {
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 10,
    marginTop: 5,
  },
  // Footer styles
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    borderTopWidth: 1,
    borderColor: '#e5e7eb',
    paddingTop: 10,
  },
  footerContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  copyright: {
    fontSize: 8,
    color: '#666666',
  },
  pageNumber: {
    fontSize: 8,
    color: '#666666',
  },
  // Page-specific styles
  subsequentPageHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderColor: '#e5e7eb',
  },
  subsequentPageTitle: {
    fontSize: 10,
    color: '#666666',
  },
  pageInfo: {
    fontSize: 10,
    color: '#666666',
  },
  unassigned: {
    fontSize: 10,
    color: '#666666',
    fontStyle: 'italic',
  },
  // Page break styles
  pageBreak: {
    height: 0,
  },
  // Table container
  tableContainer: {
    marginBottom: 10,
  },
  // Table continuation styles
  tableContinuation: {
    fontSize: 8,
    fontStyle: 'italic',
    color: '#666666',
    textAlign: 'right',
    marginTop: 3,
    marginBottom: 3,
  },
  // Table group styles to ensure tables are properly spaced
  tableGroup: {
    marginBottom: 8,
  },
});
